module.exports = __webpack_public_path__ + "static/img/8.8485ba77.png";